module.exports = __webpack_public_path__ + "fonts/n790-modern-regular.93dafe5.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/components/posters/babyroo/fonts/n790-modern-regular.woff2
// module id = 380
// module chunks = 0